import styled from "styled-components"
import { colors } from "../../constants"

const Divider = styled.div`
  background-color: ${(props) => (props.color ? props.color : `${colors.very_light_pink_three}`)};
  height: ${(props) => (props.depth ? `${props.depth}px` : "1px")};
  width: 100%;
  flex-shrink: 0;
`

export default Divider
